import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle, faApple } from '@fortawesome/free-brands-svg-icons';
import { useAuth } from '@snapi/ui-utils';
import clsx from 'clsx';
import { ButtonHTMLAttributes } from 'react';

function SocialButton({
  bg,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement> & { bg: string }) {
  return (
    <button
      className={clsx(
        bg,
        'flex flex-1 justify-center items-center h-[39px] rounded-[10px] text-white disabled:bg-gray-soft disabled:border-none hover:bg-opacity-80 focus:bg-opacity-60'
      )}
      {...props}
    >
      <h5>{props.children}</h5>
    </button>
  );
}

export const SocialSignIn: React.FC = () => {
  const {
    auth: { federatedSignInWithGoogle, federatedSignInWithApple },
  } = useAuth();
  return (
    <div className="flex justify-between gap-2">
      <div className="flex flex-1 justify-center">
        <SocialButton bg="bg-brand-google" onClick={federatedSignInWithGoogle}>
          <FontAwesomeIcon
            icon={faGoogle}
            className="w-4 h-4 mr-2"
            aria-hidden="true"
          />
          <span>Google</span>
        </SocialButton>
      </div>
      <div className="flex flex-1 justify-center">
        <SocialButton bg="bg-dark" onClick={federatedSignInWithApple}>
          <FontAwesomeIcon
            icon={faApple}
            className="w-4 h-4 mr-2"
            aria-hidden="true"
          />
          <span>Apple</span>
        </SocialButton>
      </div>
    </div>
  );
};
